import React, {useState} from 'react';
import {Form} from "react-bootstrap";
import MySwal from "sweetalert2";
import {useTranslation} from "react-i18next";

// Icons
import menuInfo from "../../assets/images/menu_info.svg";

// CSS Files
import './InputRadio.css';

const InputRadio = (props) => {
   const { t } = useTranslation();

   let infoText = t("registration_page.license_alert");

   const [defaultChecked, setDefaultChecked] = useState(props.defaultChecked)

   let checked = props.checked;
   if (props.defaultChecked !== undefined) {
      checked = defaultChecked;
   }

   const handleChange = (event) => {
      setDefaultChecked(event.target.value === "true");
      props.handleChange({
         target: {
            name: props.name,
            value: event.target.value === "true"
         }
      })
   }

   return (<>
            {props.text &&
               <Form.Label>
                  {props.text}
                  {props.showInfoButton &&
                     <img className="info-button ml-2" alt={"information button"} src={menuInfo} onClick={() => {
                        MySwal.fire({
                           allowOutsideClick: false,
                           titleText: t("common.attention"),
                           text: infoText
                        }).then(() => {
                           MySwal.close();
                        });
                     }}/>
                  }
               </Form.Label>
            }
          <div key={`inline-radio`} className={"d-flex" + (props.text ? " mb-3" : "")}>
             <Form.Check
                 inline
                 type="radio"
                 value={true}
                 checked={checked}
                 disabled={props.disabled}
                 onChange={handleChange}
                 label={props.firstRadioText}
                 aria-label={props.firstRadioText}
                 className={"w-50 mr-2 cursor-pointer "}
             />

             <Form.Check
                 inline
                 type="radio"
                 value={false}
                 checked={!checked}
                 disabled={props.disabled}
                 onChange={handleChange}
                 label={props.secondRadioText}
                 aria-label={props.secondRadioText}
                 className={"w-50 ml-2 cursor-pointer"}/>
          </div>
       </>
   )
}

export default InputRadio;